//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tableGrid from '../tableGrid'
import cellGrid from '../cellGrid'
import layer from './layer.vue'
import { FactoryUtils } from "../../utils/FactoryUtils"
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              cell:[],
              allData:{},
              tabledata:{},
              planBScroll:null,
              nav:[],
              key:''
            }
        },
        components: {
          tableGrid,
          cellGrid,
          layer
        },
        created(){
            FactoryUtils.planDetails().then(data =>{
                console.log('data',data)
                this.title = data.premium.title
                this.nav = data.premium.tableNav
                this.allData = data.premium
                this.key =  this.nav[0].key
                this.tabledata = this.allData[this.key]

            })
        },
        mounted(){
           
        },
        methods:{
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
          },
          close(){
            this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          },
          check(key){
            this.tabledata = this.allData[key]
            this.key = key
          }
        }
    }
